import { Scale } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const TheftRobbery = () => {
  const mainContent = (
    <div className="prose prose-lg max-w-none">
      <h2 className="text-3xl font-bold mb-6">Fight Charges, Protect Your Record</h2>
      <p className="text-xl text-muted-foreground mb-8">
        A theft or robbery conviction can damage your future in ways you may not expect—from jail time and fines to job loss, housing issues, and immigration consequences. At Daniel Albert Law Firm, we defend clients in Houston and surrounding areas facing theft and robbery charges.
      </p>

      <h3 className="text-2xl font-bold mb-4">Types of Theft & Robbery Offenses</h3>
      <ul className="list-disc pl-6 mb-6">
        <li>Shoplifting and petty theft</li>
        <li>Burglary and breaking & entering</li>
        <li>Armed robbery and aggravated robbery</li>
        <li>Identity theft and credit card fraud</li>
        <li>Embezzlement and white-collar theft</li>
        <li>Auto theft and receiving stolen property</li>
      </ul>

      <h3 className="text-2xl font-bold mb-4">Defense Strategies</h3>
      <p className="mb-6">
        We challenge the prosecution's evidence, question witness credibility, examine search and seizure procedures, negotiate for reduced charges or dismissals, and fight for alternative sentencing when appropriate.
      </p>

      <h3 className="text-2xl font-bold mb-4">Potential Consequences</h3>
      <ul className="list-disc pl-6 mb-8">
        <li>State jail felony to first-degree felony charges</li>
        <li>Jail or prison sentences</li>
        <li>Heavy fines and restitution</li>
        <li>Permanent criminal record</li>
        <li>Loss of professional licenses</li>
        <li>Immigration consequences for non-citizens</li>
      </ul>
    </div>
  );

  return (
    <GenericPracticePage
      title="Theft & Robbery Defense"
      subtitle="Experienced defense for theft and robbery charges in Texas"
      icon={<Scale className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default TheftRobbery;
